import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { selectError, selectShowErrorModal } from '@selectors'
import { ERROR_MODAL_CLOSE } from '@redux/actions/types'

import { Button, IconInline, Title, WHITE } from '@omnilert/components'
import Modal from '@components/modal/modal.component'

import i18n from 'i18n-js'

import useStyles from './error-modal.style'

import { BUTTON_CLOSE } from '../../assets/i18n/strings'

const ErrorModal = props => {
  const classes = useStyles(props)

  const dispatch = useDispatch()

  const error = useSelector(selectError)
  const showErrorModal = useSelector(selectShowErrorModal)

  const handleOnClickClose = () => {
    dispatch({ type: ERROR_MODAL_CLOSE })
  }

  const errorMessage = error?.message

  return (
    <Modal isVisible={showErrorModal}>
      <div>
        <div className={classes.iconContainer}>
          <IconInline
            className={classes.icon}
            name='alert'
            rotate={0}
            size={140}
          />
        </div>
        <div className={classes.modalTextContainer}>
          <Title
            color={WHITE}
            size='md'
          >
            {errorMessage}
          </Title>
        </div>
        <Button
          className={classes.button}
          fullWidth
          onClick={handleOnClickClose}
          title={i18n.t(BUTTON_CLOSE)}
          variant='solid'
        />
      </div>
    </Modal>
  )
}

export default ErrorModal
